import { logger } from "@/shared/lib/logger";

interface Metric {
  name: string;
  value: number;
  rating: string;
  id: string;
}

/** Dev: console. Production: a beacon to VITE_VITALS_URL when configured; otherwise nothing is sent. */
export async function reportWebVitals(endpoint: string | undefined, dev: boolean) {
  if (!dev && !endpoint) return;
  const { onCLS, onFCP, onINP, onLCP, onTTFB } = await import("web-vitals");
  const send = (m: Metric) => {
    if (dev)
      logger.debug(`web-vital ${m.name}`, {
        value: Math.round(m.value * 100) / 100,
        rating: m.rating,
      });
    if (endpoint) {
      const body = JSON.stringify({
        name: m.name,
        value: m.value,
        rating: m.rating,
        id: m.id,
        path: location.pathname,
      });
      try {
        navigator.sendBeacon(endpoint, new Blob([body], { type: "application/json" }));
      } catch {
        // telemetry must never break the app
      }
    }
  };
  [onCLS, onFCP, onINP, onLCP, onTTFB].forEach((observe) => observe(send));
}
